import MenuIcon from "../../assets/menu.png";
import LogoIcon from "../../assets/logo.png";
import DashboardIcon from "../../assets/dashboard.png";
import ClientsIcon from "../../assets/user.png";
import ReviewsIcon from "../../assets/star.png";
import SupportIcon from "../../assets/support.png";
import NotificationIcon from "../../assets/notification.png";
import SearchIcon from "../../assets/search-sidebar.png";
import PromotionsIcon from "../../assets/promotions.png";
import AppointmentsIcon from "../../assets/appointmnets.svg";
import TransactionsIcon from "../../assets/transactions.svg";
import RefundIcon from "../../assets/refunds.svg";
import PayoutsIcon from "../../assets/payouts.svg";
import sprovider from "../../assets/sprovider-.png";
import ScissorIcon1 from "../../assets/dashboard/scissor-hair.png";
import { NavLink } from "react-router-dom";
import { useGlobalContext } from "../../context/GlobalProvider";

const Sidebar = () => {
  const { sidebarOpen, setSidebarOpen } = useGlobalContext();

  const Menus = [
    { title: "Dashboard", src: DashboardIcon, to: "/admin/dashboard" },
    { title: "Clients", src: ClientsIcon, to: "/admin/clients" },
    {
      title: "Service Providers",
      src: sprovider,
      to: "/admin/service-providers",
    },
    { title: "Appointments", src: AppointmentsIcon, to: "/admin/appointments" },
    { title: "Transactions", src: TransactionsIcon, to: "/admin/transactions" },
    { title: "Refunds", src: RefundIcon, to: "/admin/refund" },
    { title: "Payouts", src: PayoutsIcon, to: "/admin/payouts" },
    { title: "Reviews", src: ReviewsIcon, to: "/admin/reviews" },
    { title: "Promotions", src: PromotionsIcon, to: "/admin/promotions" },
    {
      title: "Support Tickets",
      src: SupportIcon,
      to: "/admin/support-tickets",
    },
    {
      title: "Notifications",
      src: NotificationIcon,
      to: "/admin/notifications",
    },
    { title: "Search List", src: SearchIcon, to: "/admin/search-list" },
  ];

  return (
    <div
      className={` ${
        sidebarOpen ? "w-52 main_sidenav " : "w-[90px]"
      } h-full flex flex-col bg-primary-500 py-5 pl-5 relative duration-300 z-10`}
    >
      {sidebarOpen && (
        <div className="bg-img absolute bottom-0 left-0 w-44">
          <img src={ScissorIcon1} alt="" />
        </div>
      )}
      <img
        src={MenuIcon}
        className={`absolute block p-1 bg-primary-900 cursor-pointer -right-3 top-2.5 w-8 rounded-full  ${
          !sidebarOpen && "rotate-180"
        }`}
        onClick={() => setSidebarOpen((prev) => !prev)}
        alt="control-img"
      />

      <div className="flex items-center justify-center h-[55px]">
        <img
          src={LogoIcon}
          className={`cursor-pointer duration-500 mr-5 w-10 ${
            sidebarOpen && "rotate-[360deg] w-14"
          }`}
          alt="logo-img"
        />
      </div>
      <ul className="mt-4 overflow-y-scroll no-scrollbar">
        {Menus.map((Menu, index) => (
          <li key={index}>
            <NavLink
              to={Menu.to}
              className={({ isActive }) =>
                `side-menu__item ${isActive && "active"} whitespace-nowrap`
              }
            >
              <span className="shape1" />
              <span className="shape2" />
              <img
                className="w-4 h-4 ml-1"
                src={Menu.src}
                alt={Menu.title.toLowerCase()}
              />
              <span
                className={`${
                  !sidebarOpen && "hidden"
                } 2xl:text-sm ml-2 cursor-pointer text-[#8f6a70] font-medium  text-xs origin-left duration-200`}
              >
                {Menu.title}
              </span>
            </NavLink>
          </li>
        ))}
      </ul>
      <span
        className={`text-xs absolute bottom-3 w-full left-11 ${
          sidebarOpen ? "block" : "hidden"
        }`}
      >
        v1.All Rights Reserved
      </span>
    </div>
  );
};

export default Sidebar;
